<template>
  <v-card class="h-100">
    <app-header></app-header>
    <div :class="isLogin?'mt-70':''"></div>
    <v-container grid-list-xl>
      <v-layout row wrap justify-center>
        <v-flex xs12 md7 lg10 class="col-height-auto">
          <div class="font-30 fw-700 mb-5 text-center">KYC</div>
          <div class="font-16 fw-400">
            <p>Depending on the functions that you seek to enable on your account and IOB’s risk determination, IOB may, in its discretion, require identity verification and other screening procedures with respect to you or transactions associated with your SiP Account.</p>
            <p>These verification and screening procedures may include, without limitation, checking the information you provide against the Specially Designated Nationals and Blocked Persons list maintained by the U.S. Office of Foreign Assets Control, the U.S. Department of Commerce Denied Persons list, and any similar list issued by any U.S. governmental authority or any other governmental authority prohibiting or limiting business activities or transactions with any persons.</p>
            <p>You may be required to provide IOB with certain personal information, including, but not limited to, your name, address, telephone number, email address, date of birth, taxpayer identification number, government identification number, photograph of your government-issued ID or other photographic proof of your identity, and information regarding your bank account.</p>
            <p>You hereby authorize IOB, directly or through a third party, to make any inquiries IOB considers necessary to verify your identity and/or protect against fraud, including but not limited to: (a) query identity information contained in public reports (e.g., your name, address, past addresses, or date of birth); (b) query account information associated with your linked bank account (e.g., name or account balance); and (c) take action IOB reasonably deems necessary based on the results of such inquiries and reports.</p>
            <p>You further authorize any and all third parties to which such inquiries or requests may be directed to fully respond to such inquiries or requests. IOB will have no liability or responsibility for any permanent or temporary inability to access or use any Services, including your inability to withdraw Tokens or execute Trades, as a result of any identity verification or other screening procedures.</p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>
<style>
</style>
<script>
import config from "../../config.js";
export default {
  data() {
    return {};
  },
  computed: {
    isLogin() {
      if (
        this.$store.state.user.token != null &&
        this.$store.state.user.token != ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {},
  mounted: function() {},
  watch: {},
  methods: {}
};
</script>


// WEBPACK FOOTER //
// KYC.vue?1f66c6dc